import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { HitSubStatusType } from './hit-sub-status-type.interface';
import { HitSubStatusTypeService } from './hit-sub-status-type.service';
const service = new HitSubStatusTypeService();

export interface HitSubStatusTypeState {
   hitSubStatusTypes: Array<HitSubStatusType>;
}

const HitSubStatusTypeStore: Module<HitSubStatusTypeState, StoreState> = {
   namespaced: true,
   state: {
      hitSubStatusTypes: [],
   },
   getters: {},
   mutations: {
      SET_HIT_SUB_STATUS_TYPES(state: HitSubStatusTypeState, hitSubStatusTypes: Array<HitSubStatusType>) {
         state.hitSubStatusTypes = hitSubStatusTypes;
      },
   },
   actions: {
      async getHitSubStatusTypes(context) {
         const { data: hitSubStatusTypes } = await service.getHitSubStatusTypes();
         context.commit('SET_HIT_SUB_STATUS_TYPES', hitSubStatusTypes);
         return hitSubStatusTypes;
      },
   },
};

export default HitSubStatusTypeStore;
